import React, { useContext, useState, useEffect } from "react";
import { ServiceContext } from "../../../context/ServiceContext";
import { Link } from "react-router-dom";
import { Dropdown, Spinner } from "react-bootstrap";
import { useGetNotificationsFn, useNotificationsUpdateFn } from "../../../actions/notifications-actions";
import { useNavigate } from "react-router-dom";
import { dateTimeHandler } from "../../../utils/ComponentUtilse";


function Notifications(toggle) {

    const navigate = useNavigate();

    const { getEmployeeUUID, setEmployeeUUID } = useContext(ServiceContext);

    const [data, setData] = useState([]);

    const {
        data: getNotificationsFn,
        isLoading: loadingNotificationsFn,
        refetch: refetchNotificationsFn,
    } = useGetNotificationsFn(getEmployeeUUID);

    const {
        mutate: patchNotificationsFn,
        isLoading: loadingNotifications,
    } = useNotificationsUpdateFn();


    useEffect(() => {
        if (getNotificationsFn) {
            setData(getNotificationsFn.filter((n) => n.is_read === false));
        }
    }, [getNotificationsFn]);

    const handleNotificationClick = (item, id) => {

        let userData = {
            is_read: true,
        }

        patchNotificationsFn(
            { id, userData },
            {
                onSuccess: (response) => {
                    refetchNotificationsFn()
                },
            }
        );

        switch (item.code) {
            case "EmployeeCreation":
                navigate(`/employee-profile-view/${item?.notify_id}`);
                break;
            case "DocumentExpiry":
                navigate("/expiry-dashboard/");
                break;
            case "OnBoardEmployee":
                navigate(`/employee-profile-view/${item?.notify_id}`);
                break;
            case "NewAnnouncement":
                navigate("/list-announcements/");
                break;
            case "NewTask":
                navigate("/list-task/");
                break;
            case "NewPayslip":
                navigate("/list-payslips/");
                break;
            case "NewLeaveRequest":
                navigate("/admin-leave-list/");
                break;
            default:
                break;
        }
    };

    return (

        <Dropdown as="li" className="nav-item dropdown notification_dropdown" Style="cursor:pointer">
            <Dropdown.Toggle to={"#"}
                className="nav-link i-false  ai-icon"
                as="div"
            >
                <svg
                    width="26"
                    height="28"
                    viewBox="0 0 26 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.45251 25.6682C10.0606 27.0357 11.4091 28 13.0006 28C14.5922 28 15.9407 27.0357 16.5488 25.6682C15.4266 25.7231 14.2596 25.76 13.0006 25.76C11.7418 25.76 10.5748 25.7231 9.45251 25.6682Z"
                        fill="#3E4954"
                    />
                    <path
                        d="M25.3531 19.74C23.8769 17.8785 21.3995 14.2195 21.3995 10.64C21.3995 7.09073 19.1192 3.89758 15.7995 2.72382C15.7592 1.21406 14.5183 0 13.0006 0C11.4819 0 10.2421 1.21406 10.2017 2.72382C6.88095 3.89758 4.60064 7.09073 4.60064 10.64C4.60064 14.2207 2.12434 17.8785 0.647062 19.74C0.154273 20.3616 0.00191325 21.1825 0.240515 21.9363C0.473484 22.6721 1.05361 23.2422 1.79282 23.4595C3.08755 23.8415 5.20991 24.2715 8.44676 24.491C9.84785 24.5851 11.3543 24.64 13.0007 24.64C14.646 24.64 16.1524 24.5851 17.5535 24.491C20.7914 24.2715 22.9127 23.8415 24.2085 23.4595C24.9477 23.2422 25.5268 22.6722 25.7597 21.9363C25.9983 21.1825 25.8448 20.3616 25.3531 19.74Z"
                        fill="#3E4954"
                    />
                </svg>
                <span className="badge light text-white bg-primary rounded-circle">
                    {data?.length}
                </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
                className="dropdown-menu dropdown-menu-right" align="end"
            >
                <div
                    id="DZ_W_Notification1"
                    className={` widget-media dz-scroll p-3 height380 ${toggle === "notification"
                        ? ""
                        : ""
                        }`}
                >
                    <ul className="timeline">
                        {loadingNotificationsFn ?
                            <li>
                                <div className="timeline-panel">
                                    <Spinner animation="border" size="lg" className="me-2" />
                                </div>
                            </li>

                            : data.length > 0
                                ? data.map((item, i) => {
                                    let iconClassName = "";

                                    // Determine icon based on item.code
                                    switch (item.code) {
                                        case "EmployeeCreation":
                                            iconClassName = "fa fa-user";
                                            break;
                                        case "DocumentExpiry":
                                            iconClassName = "fa fa-file";
                                            break;
                                        case "OnBoardEmployee":
                                            iconClassName = "fa fa-user";
                                            break;
                                        case "NewAnnouncement":
                                            iconClassName = "fa fa-bullhorn";
                                            break;
                                        case "NewTask":
                                            iconClassName = "fa fa-tasks";
                                            break;
                                        case "NewPayslip":
                                            iconClassName = "fa fa-file";
                                            break;
                                        case "NewLeaveRequest":
                                            iconClassName = "fa fa-envelope";
                                            break;
                                        default:
                                            iconClassName = "fa fa-bell";
                                            break;
                                    }
                                    return (
                                        <li>
                                            <div className="timeline-panel" Style="cursor:pointer;" onClick={() => handleNotificationClick(item, item?.id)}>
                                                <div className="media me-2 media-success">
                                                    <i className={iconClassName}></i>
                                                </div>
                                                <div className="media-body">
                                                    <h6 className="mb-1">
                                                        {item?.message}
                                                    </h6>
                                                    <small className="d-block">
                                                        {dateTimeHandler(item?.created_at)}
                                                    </small>
                                                </div>
                                            </div>
                                        </li>

                                    );
                                })

                                :
                                <li>
                                    <div className="timeline-panel">
                                        <div className="media-body text-center">
                                            <h6 className="mb-1">
                                                No Notifications
                                            </h6>
                                        </div>

                                    </div>
                                </li>
                        }

                    </ul>
                </div>
                <Link to={"/notification-list/"} className="all-notification">
                    See all notifications{" "}
                    <i className="ti-arrow-right"></i>
                </Link>
            </Dropdown.Menu>
        </Dropdown>

    );
}

export default Notifications;